import { Extension } from '@tiptap/core';

const NUMBER_PREFIX = /^\d+(?:\.\d+)*\.$/;

function readPrefix(value: unknown): string | null {
  return typeof value === 'string' && NUMBER_PREFIX.test(value) ? value : null;
}

/**
 * Lidnummering zoals 2.1, 2.2 in een genummerde lijst (artikelen in een verwerkersovereenkomst
 * of voorwaarden). Het voorvoegsel "2." komt mee met tekst uit Word (zie pasteCleanup); een
 * nieuw punt telt verder. De CSS in sectionStyles zet het voorvoegsel voor het nummer.
 */
export const ListNumberPrefix = Extension.create({
  name: 'listNumberPrefix',

  addGlobalAttributes() {
    return [
      {
        types: ['orderedList'],
        attributes: {
          numberPrefix: {
            default: null,
            parseHTML: (element) => readPrefix(element.getAttribute('data-number-prefix')),
            renderHTML: (attributes) => {
              const prefix = readPrefix(attributes.numberPrefix);
              return prefix ? { 'data-number-prefix': prefix, style: `--number-prefix: "${prefix}"` } : {};
            },
          },
        },
      },
    ];
  },
});
